import Step13 from '@/Classes/FollowUp/FollowUpPatint';
export default {
  data() {
    return {
      patientMedicalItem: new Step13.Step13(null, null, null),
      allUsesMedicalItems: [],
    };
  },
  methods: {
    addMedicalItemUsage: function () {
      if (!this.patientMedicalItem.medicalItemId) {
        this.showErrorAlert('اقلام مصرفی نمی تواند خالی باشد');
        return;
      }
      if (!this.patientMedicalItem.count) {
        this.showErrorAlert('تعداد نمی تواند خالی باشد');
        return;
      }
      this.patientMedicalItem.patientId = Number(this.patientId);
      this.addPatientMedicalItemFunction(this.patientMedicalItem);
    },
    setData: function (data) {
      this.patientMedicalItem = new Step13.Step13(null, null, null);
      this.allUsesMedicalItems = [];
      for (let i = 0; i < data.length; i++) {
        this.allUsesMedicalItems.push({
          id: data[i].id,
          count: data[i].count,
          medicalItem: data[i].medicalItem.title,
        });
      }
    },
    goToNextStep: function () {
      this.$root.$refs.FollowUpPatient.changeTab4Step(3, true);
    },
    backToStep12: function () {
      this.$root.$refs.FollowUpPatient.changeTab4Step(1, true);
    },
  },
};
